/**
 * Aona India Theme Sliding & Scroll Entrance Animations
 */
function initThemeScrollAnimations() {
  const scrollElements = document.querySelectorAll(".scroll-animation");
  if (!scrollElements.length) return;

  if ("IntersectionObserver" in window) {
    const observer = new IntersectionObserver((entries, obs) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("active");
        }
      });
    }, {
      rootMargin: "0px 0px -50px 0px",
      threshold: 0.1
    });

    scrollElements.forEach((el) => {
      observer.observe(el);
    });
  } else {
    // Fallback for older browsers
    const handleScrollAnimation = () => {
      scrollElements.forEach((el) => {
        const top = el.getBoundingClientRect().top;
        const windowHeight = window.innerHeight || document.documentElement.clientHeight;
        if (top <= windowHeight * 0.9) {
          el.classList.add("active");
        }
      });
    };

    handleScrollAnimation();
    window.addEventListener("scroll", handleScrollAnimation, { passive: true });
    window.addEventListener("resize", handleScrollAnimation, { passive: true });
  }
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initThemeScrollAnimations);
} else {
  initThemeScrollAnimations();
}
document.addEventListener("shopify:section:load", initThemeScrollAnimations);